export default "__VITE_ASSET__cfbec8fc__"